import { styled } from "@mui/material/styles";

const DocumentsMain = styled("div")(({ theme }) => ({
  marginBottom: "30px",
  "& h6": {
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "22px",
    letterSpacing: "-0.02em",
    color: "rgba(11, 11, 11, 0.5)",
    fontFamily: theme.typography.fontFamily,
  },
  "& .DocumentsWrapper": {
    marginTop: "5px",
    display: "flex",
    gap: "20px",
    "& img": {
      maxWidth: "100%",
      height: "auto",
    },
  },
}));
export { DocumentsMain };
